// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1MtfO","productName":"Table_productName__yokdG"};